export const episodePluralMapping: Record<string, string> = {
  '=1': 'Heroban_SD_Metadata_1Episode_txt',
  '=2': 'Heroban_SD_Metadata_2Episodes_txt',
  other: 'Heroban_SD_Metadata_Episodes_txt',
};
